// to make reviews
// 1. export from loox
// 2. import to google sheets. remove what you dont  want
// 3. use CSV->JSON converter https://www.convertcsv.com/csv-to-json.htm. group by field 4
var reviews = {
   "6634911596718": [
      {
         "nickname": "Tabitha R.",
         "review": "Soo adorable and delicate.",
         "length": 26,
         "handle": "sacred-heart-necklace"
      },
      {
         "nickname": "Mariana R.",
         "review": "So in love with it!! Great quality and so delicate 😍",
         "length": 53,
         "handle": "sacred-heart-necklace"
      },
      {
         "nickname": "Lina L.",
         "review": "I really love my necklace, it’s super cute. I didn’t expect it to be so small though, but I don’t mind it.",
         "length": 106,
         "handle": "sacred-heart-necklace"
      },
      {
         "nickname": "Chloe C.",
         "review": "I love thos necklace I wear it everyday it now my favorite peice of jewelry I own I already ordered more from here I definitely recommend this necklace to anyone who like dainty jewelry",
         "length": 185,
         "handle": "sacred-heart-necklace"
      },
      {
         "nickname": "janet m.",
         "review": "Even though it's expensive I wouldn't order any necklaces from any other place. I have a necklace I ordered since the beginning of the year and it still hasn't turned green even after wearing it many times during my shower.",
         "length": 223,
         "handle": "sacred-heart-necklace"
      },
      {
         "nickname": "Joona S.",
         "review": "I ordered two pieces of jewelry. At first postal service miss placed package but then retailer sent free extra piece for shipping being late. \n\nJewels are nice, unfortunately other one's plating wore off quickly (not usual) but I got refund of it. \n\nAfter all I still recommend this 100%. Awesome friendly customer support with fast response. Also other jewels other than one are still in good condition.",
         "length": 404,
         "handle": "sacred-heart-necklace"
      }
   ],
   "6350623867054": [
      {
         "nickname": "Kayla L.",
         "review": "Love this jewelry! My staple",
         "length": 28,
         "handle": "opal-ear-huggies-1"
      },
      {
         "nickname": "Roba A.",
         "review": "I lovvvveeeeee itttttt❤️❤️❤️❤️",
         "length": 30,
         "handle": "opal-ear-huggies-dainty-everyday-wear-in-gold"
      },
      {
         "nickname": "Wanda R.",
         "review": "My daughter's birthstone. They are beautiful!\n",
         "length": 46,
         "handle": "opal-ear-huggies-dainty-everyday-wear-in-gold"
      },
      {
         "nickname": "Mariana O.",
         "review": "Super cute and I love wearing it as a second piercing huggy :) stunning !!!",
         "length": 75,
         "handle": "opal-ear-huggies-dainty-everyday-wear-in-gold"
      },
      {
         "nickname": "Delaney G.",
         "review": "love these earrings!! my new every day earrings :,) very pretty and high quality ",
         "length": 81,
         "handle": "opal-ear-huggies-dainty-everyday-wear-in-gold"
      },
      {
         "nickname": "Noah B.",
         "review": "Bought them as a gift for my sister but I think they look nice and she loves them",
         "length": 81,
         "handle": "opal-ear-huggies-dainty-everyday-wear-in-gold"
      },
      {
         "nickname": "Rosa Z.",
         "review": "Love the earring!! Paired it with some purple opal earring I have. Very beautiful!!",
         "length": 83,
         "handle": "opal-ear-huggies-dainty-everyday-wear-in-gold"
      },
      {
         "nickname": "Morgan M.",
         "review": "SO COMFORTABLE. I get comments all the time and they don’t irritate my sensitive ears.",
         "length": 86,
         "handle": "opal-ear-huggies-1"
      },
      {
         "nickname": "Patricia P.",
         "review": "These earrings are beautiful! They hug my earlobe perfectly and add a subtle elegance to any outfit.",
         "length": 100,
         "handle": "opal-ear-huggies-dainty-everyday-wear-in-gold"
      },
      {
         "nickname": "Sultana A.",
         "review": "IN LOVE! Unfortunately such beauty can never be captured on camera but this is definitely my best purchase.",
         "length": 107,
         "handle": "opal-ear-huggies-1"
      },
      {
         "nickname": "Clarissa C.",
         "review": "The opal ear huggies are EXACTLY what I was hoping for. Super comfortable and cute. Wish I had them with different metals and stones because they are perfect!❤❤❤",
         "length": 161,
         "handle": "opal-ear-huggies-1"
      },
      {
         "nickname": "Kiyah H.",
         "review": "The opal huggies are my favorite. I can match them with other pairs of earrings that I already have. They don’t make my ears itch and I would highly recommend! <3",
         "length": 162,
         "handle": "opal-ear-huggies-dainty-everyday-wear-in-gold"
      },
      {
         "nickname": "Maria H.",
         "review": "I found your Shop via TikTok and was not really sure about it at first - but i absolutly love it! For international shipping it acutually did not take that long  to arrive!",
         "length": 172,
         "handle": "opal-ear-huggies-1"
      },
      {
         "nickname": "Jasmine H.",
         "review": "I really love this pair of earrings and how they rest on the ear, opal is one of my favorite stones so I’m in love with these! The gold also adds to the stone as well. Very beautiful pair of earrings for an affordable price without sacrificing quality.",
         "length": 252,
         "handle": "opal-ear-huggies-1"
      },
      {
         "nickname": "Caitlyn S.",
         "review": "My favourite item I have ordered from this store!! These earrings don’t irritate my sensitive ears and are the cutest in the world. I can wear them to sleep and feel completely comfortable. If Serendipity made these with different gems, I would buy those too ;)",
         "length": 261,
         "handle": "opal-ear-huggies-1"
      }
   ],
   "7318688497838": [
      {
         "nickname": "Marie L.",
         "review": "Great Product, I’m so in love ",
         "length": 30,
         "handle": "geode-box-60"
      }
   ],
   "6704959848622": [
      {
         "nickname": "Socorro Z.",
         "review": "Very good quality I love them!",
         "length": 30,
         "handle": "trio-tilt-studs"
      },
      {
         "nickname": "Emily W.",
         "review": "Absolutely lovely shop! Right pricing for quality products and super cute items.",
         "length": 80,
         "handle": "trio-tilt-studs"
      }
   ],
   "6710840033454": [
      {
         "nickname": "Maya C.",
         "review": "Amazing quality and packaging!",
         "length": 30,
         "handle": "opal-hamsa-necklace-1"
      }
   ],
   "6645033730222": [
      {
         "nickname": "Andreina F.",
         "review": "I’m in love with my purchase!!",
         "length": 30,
         "handle": "opal-sun-necklace"
      },
      {
         "nickname": "Christian F.",
         "review": "The necklace is so beautiful, it’s gonna be one of my staple items in my accessories ",
         "length": 85,
         "handle": "opal-sun-necklace"
      }
   ],
   "6128975184046": [
      {
         "nickname": "Mia K.",
         "review": "Beautiful! Would recommend! :D",
         "length": 30,
         "handle": "galaxy-ear-huggies"
      }
   ],
   "6631198654638": [
      {
         "nickname": "Renee J.",
         "review": "Love it! Exactly as advertised.",
         "length": 31,
         "handle": "evil-eye-moon-necklace"
      }
   ],
   "6280095465646": [
      {
         "nickname": "Jamal D.",
         "review": "Beautiful Necklace great prices",
         "length": 31,
         "handle": "galaxy-opal-necklace"
      },
      {
         "nickname": "Ashley P.",
         "review": "Its beautiful and I really love it. It was fast delivery\n",
         "length": 57,
         "handle": "galaxy-opal-necklace"
      },
      {
         "nickname": "Haley B.",
         "review": "This necklace is absolutely gorgeous!! And it’s also the perfect size!",
         "length": 70,
         "handle": "galaxy-opal-necklace"
      },
      {
         "nickname": "Virginia D.",
         "review": "The quality is so good and the seller is so so nice. Would totally recommend!! The packaging is nice too !",
         "length": 106,
         "handle": "galaxy-opal-necklace-dainty-14k-gold"
      },
      {
         "nickname": "Morgan D.",
         "review": "Absolutely gorgeous necklace! Obsessed! Chain is slightly shorter than I expected but I’m still super happy with it!",
         "length": 116,
         "handle": "galaxy-opal-necklace-dainty-14k-gold"
      },
      {
         "nickname": "Betsy D.",
         "review": "I am absolutely in love with my Serendipity jewelry! I’ve been planning outfits just to make sure I can wear the pieces!",
         "length": 120,
         "handle": "galaxy-opal-necklace-dainty-14k-gold"
      },
      {
         "nickname": "Letis Y.",
         "review": "Very dainty, very cute, worth the buy! I’m absolutely buying from this company again. Thank You to those who created it. ",
         "length": 121,
         "handle": "galaxy-opal-necklace"
      },
      {
         "nickname": "Jeanne  M.",
         "review": "I bought this as a gift, and the recipient loves it! I’d love for your website to have a gift option for adding a  gift message. ",
         "length": 129,
         "handle": "galaxy-opal-necklace-dainty-14k-gold"
      },
      {
         "nickname": "Chan A.",
         "review": "It’s BEAUTIFUL. Even more-so in person. The chain is the perfect length and she receives compliments every time she wears it out.",
         "length": 129,
         "handle": "galaxy-opal-necklace"
      },
      {
         "nickname": "Catherine  S.",
         "review": "this necklace goes with every piece of jewelry i have, it’s the perfect pairing. i love how light it feels on my neck and how cute it looks :)",
         "length": 142,
         "handle": "galaxy-opal-necklace"
      },
      {
         "nickname": "Lexi E.",
         "review": "I love the necklace! My only recommendation would be slightly larger clasps! They’re kind of hard to handle. I absolutely love the jewelry though!",
         "length": 146,
         "handle": "galaxy-opal-necklace"
      },
      {
         "nickname": "Kayla L.",
         "review": "This necklace is absolutely gorgeous. The opal is bright and beautiful and together are just one stunning necklace. Came in beautiful packaging with a sticker as well. Will definitely be ordering from here again",
         "length": 211,
         "handle": "galaxy-opal-necklace"
      }
   ],
   "6272714473646": [
      {
         "nickname": "Panashe M.",
         "review": "my girlfriend loves the necklace",
         "length": 32,
         "handle": "rose-quartz-essential-oil-perfume-bottle-necklace-2"
      }
   ],
   "4563198672980": [
      {
         "nickname": "Jenine B.",
         "review": "Beautiful, as seen on Instagram. ",
         "length": 33,
         "handle": "amethyst-tree-of-life-necklace-2"
      }
   ],
   "6264731107502": [
      {
         "nickname": "Emma M.",
         "review": "Love the earrings they’re perfect!",
         "length": 34,
         "handle": "opal-star-ear-huggies"
      },
      {
         "nickname": "Kurtisha H.",
         "review": "Original, unique pieces, will certainly purchase again!",
         "length": 55,
         "handle": "opal-star-ear-huggies"
      },
      {
         "nickname": "Haley B.",
         "review": "My order came in in no time! And the jewelry I purchased is so cute!",
         "length": 68,
         "handle": "opal-star-ear-huggies"
      },
      {
         "nickname": "Colleen S.",
         "review": "The earrings are even more beautiful in person! Highly recommend getting them!",
         "length": 78,
         "handle": "opal-star-ear-huggies"
      }
   ],
   "6016741900462": [
      {
         "nickname": "Kate B.",
         "review": "Love it so much! It’s so beautiful",
         "length": 34,
         "handle": "locket-necklace"
      },
      {
         "nickname": "Rebecca  W.",
         "review": "Really great quality! I love the details on the chain and I really love the face of the locket",
         "length": 94,
         "handle": "locket-necklace"
      },
      {
         "nickname": "Mckinsey B.",
         "review": "I love them so much. They actually are smaller then what I thought, but they are still super cute.",
         "length": 98,
         "handle": "locket-necklace"
      },
      {
         "nickname": "Sarah A.",
         "review": "I've wanted a locket for the longest time and this is the perfect piece! So beautiful, I could wear it every day!",
         "length": 113,
         "handle": "locket-necklace"
      },
      {
         "nickname": "Richard A.",
         "review": "Bought the locket for my girlfriend and she loves it so much! The quality is very premium and looks expensive too. She has a photo of us and a photo of her dog that recently passed away. A real good gift to give to someone. Highly recommend it.",
         "length": 244,
         "handle": "locket-necklace"
      }
   ],
   "4686416609364": [
      {
         "nickname": "Joy S.",
         "review": "I got it as a gift and she loved it",
         "length": 35,
         "handle": "starry-necklace"
      },
      {
         "nickname": "Marilyn Z.",
         "review": "I love the necklaces I’ve gotten so many compliments on them!! Amazing!!",
         "length": 72,
         "handle": "starry-necklace"
      },
      {
         "nickname": "J. G.",
         "review": "It’s gorgeous, it is small and very pretty. Shiny and not too much so that it’s the only thing to look at while you’re wearing it. ",
         "length": 131,
         "handle": "starry-necklace"
      }
   ],
   "6061850230958": [
      {
         "nickname": "Janine V.",
         "review": "Very nice. Cannot wait to wear it!!",
         "length": 35,
         "handle": "amazon-essential-oil-perfume-bottle-necklace"
      },
      {
         "nickname": "Shantel A.",
         "review": "I love this necklace! When I saw it I immediately wanted to buy an other one! They are so beautiful 🤩",
         "length": 102,
         "handle": "amazon-essential-oil-perfume-bottle-necklace"
      },
      {
         "nickname": "Yulia S.",
         "review": "Gorgeous jewelry! Amazing quality! Got so many compliments on everything I ordered!!!it’s so unique and delicate! Love 💗 it!",
         "length": 125,
         "handle": "amazon-essential-oil-perfume-bottle-necklace"
      }
   ],
   "4638212587604": [
      {
         "nickname": "Julie N.",
         "review": "Such a beautiful and useful necklace",
         "length": 36,
         "handle": "fluorite-essential-oil-perfume-bottle-necklace-silver"
      }
   ],
   "5962496344238": [
      {
         "nickname": "Alexis  C.",
         "review": "I love my ring I never take it off!!",
         "length": 36,
         "handle": "amethyst-ring-6"
      }
   ],
   "6620652798126": [
      {
         "nickname": "Katie R.",
         "review": "Incredible beautiful earrings so elegant",
         "length": 40,
         "handle": "silver-opal-ear-huggies"
      },
      {
         "nickname": "Anna Z.",
         "review": "I love how comfortable they are and easy to place into the ear. The opal is also very beautiful!",
         "length": 96,
         "handle": "silver-opal-ear-huggies"
      },
      {
         "nickname": "Mariana T.",
         "review": "Oh my gosh! I love these soooo much. I definitely think they should start producing signet rings because they'd be amazing at it.",
         "length": 129,
         "handle": "silver-opal-ear-huggies"
      },
      {
         "nickname": "Nahomy N.",
         "review": "I've been looking for a pair of silver huggie earrings with opal for such a long time, and I'm really glad I came across Jewelry by Serendipity!! These earrings are absolutely perfect! They're not insanely tiny, but not super big. The starburst design is about the size of my thumb nail, a perfect size to make a bold statement with smaller jewelry. I was extremely worried that I wouldn't be able to wear these and couldn't exactly find whether or not they're hypoallergenic, but so far I've had no issues. I'll definitely update my review if things change. But thank you so so much for these lovely earrings! I'm super excited to debut them on my wedding day! ",
         "length": 662,
         "handle": "silver-opal-ear-huggies"
      }
   ],
   "6704905060526": [
      {
         "nickname": "Kayla O.",
         "review": "Ring was Better then I thought. Love it !",
         "length": 41,
         "handle": "opal-diamante-ring-crystal-ring"
      },
      {
         "nickname": "Katie R.",
         "review": "The most stunning ring, so unusual. Amazing quality ",
         "length": 52,
         "handle": "opal-diamante-ring-crystal-ring"
      },
      {
         "nickname": "Nola S.",
         "review": "Came quick! Adorable, good metal, love it all together ",
         "length": 55,
         "handle": "opal-diamante-ring-crystal-ring"
      },
      {
         "nickname": "Aireli C.",
         "review": "Such a cute little ring , I have gotten so many compliments ☺️",
         "length": 62,
         "handle": "opal-diamante-ring-crystal-ring"
      },
      {
         "nickname": "Sylvia W.",
         "review": "It’s beautiful. Can’t wait for my day to open it at Christmas.",
         "length": 62,
         "handle": "opal-diamante-ring-crystal-ring"
      },
      {
         "nickname": "Jen G.",
         "review": "Love this more than anything my boyfriend got it for me and it’s perfect",
         "length": 72,
         "handle": "opal-diamante-ring-crystal-ring"
      },
      {
         "nickname": "Esperanza  V.",
         "review": "I love my rose quartz necklace everything about it is absolutely  amazing and the ring gorgeous",
         "length": 95,
         "handle": "opal-diamante-ring-crystal-ring"
      },
      {
         "nickname": "Karla M.",
         "review": "This ring is very pretty I’m in love with opal so getting an opal ring that is genuinely cute is what I wanted and I got it!",
         "length": 124,
         "handle": "opal-diamante-ring-crystal-ring"
      },
      {
         "nickname": "Brenda G.",
         "review": "My boyfriend bought this ring for me as a gift and it is absolutely beautiful ! I wear it every day . I am definitely buying again soon .",
         "length": 137,
         "handle": "opal-diamante-ring-crystal-ring"
      },
      {
         "nickname": "Destiny D.",
         "review": "This is the first time ordering from them and I absolutely love the ring I only take it off in the shower. And it is packaged with so much care . I love it",
         "length": 155,
         "handle": "opal-diamante-ring-crystal-ring"
      },
      {
         "nickname": "Diana B.",
         "review": "I loved how fast the shipping was, the packaging, the little box it comes in. It was smaller than expected but absolutely gorgeous ! I will definitely buy from Serendipity again ! 😍",
         "length": 182,
         "handle": "opal-diamante-ring-crystal-ring"
      }
   ],
   "6632988016814": [
      {
         "nickname": "Haylee B.",
         "review": "I love the little flower it’s so prettyyy",
         "length": 41,
         "handle": "opal-flower-necklace"
      }
   ],
   "7432555036905": [
      {
         "nickname": "Betsy A.",
         "review": "I came fast . This ring is really awesome",
         "length": 41,
         "handle": "luna-ring"
      },
      {
         "nickname": "Robin  S.",
         "review": "The ring is beautiful. I bought it for my daughter and she absolutely loves it.\n",
         "length": 80,
         "handle": "luna-ring"
      },
      {
         "nickname": "Maressa H.",
         "review": "Beautiful ring! Shipping was quick and beautifully packaged. Very happy with my purchase!",
         "length": 89,
         "handle": "luna-ring"
      },
      {
         "nickname": "Mélo P.",
         "review": "Had a size issue but customer service was very quick to respond and so understanding. 100% reccomend ! Such an awesome brand !",
         "length": 126,
         "handle": "luna-ring"
      },
      {
         "nickname": "Nancy W.",
         "review": "Love this ring! It’s even prettier in person. Sizing was perfect and it spins so smoothly-will be buying it in silver for sure.",
         "length": 127,
         "handle": "luna-ring"
      },
      {
         "nickname": "Jennifer L.",
         "review": "Shipping was very quick (the shipping is also affordable which is very nice). Such a cute ring! Spins smoothly and it’s great quality!",
         "length": 134,
         "handle": "luna-ring"
      },
      {
         "nickname": "Audrey P.",
         "review": "My parents got me the Luna ring for Christmas and I’m obsessed! I saw it on TikTok and subtly shared the link via text lol. It’s beautiful and the fact that it spins is incredible!",
         "length": 180,
         "handle": "luna-ring"
      },
      {
         "nickname": "Holly R.",
         "review": "I bought this to help with my anxiety and destroying my fingers. It’s already helped so much. I loved having an option to get it in silver and it will be adorning my thumb for a long time to come!",
         "length": 196,
         "handle": "luna-ring"
      }
   ],
   "6710828662958": [
      {
         "nickname": "Wanda R.",
         "review": "Simple and elegant. My daughter loves it!",
         "length": 41,
         "handle": "opal-necklace"
      },
      {
         "nickname": "Dana P.",
         "review": "Very pretty and dainty necklace. Opal is of good quality and the necklace was reasonably priced and shipped quickly. would definitely recommend.",
         "length": 144,
         "handle": "opal-necklace"
      }
   ],
   "6612704526510": [
      {
         "nickname": "Katie R.",
         "review": "Gorgeous stunning piece absolutely love it",
         "length": 42,
         "handle": "silver-opal-star-necklace"
      }
   ],
   "6272850854062": [
      {
         "nickname": "Devin B.",
         "review": "Got it for my girlfriend and she loves it!",
         "length": 42,
         "handle": "hummingbird-necklace-1"
      },
      {
         "nickname": "Helene H.",
         "review": "The chain is a perfect length and added to the look of such a small and detailed piece of jewelry.",
         "length": 98,
         "handle": "hummingbird-necklace-1"
      }
   ],
   "4417765900372": [
      {
         "nickname": "Tyler  R.",
         "review": "Best gift I ever got my witchy girlfriend\n",
         "length": 42,
         "handle": "amethyst-halo-necklace"
      }
   ],
   "6275267920046": [
      {
         "nickname": "Mackenzie C.",
         "review": "Wife loves the ring. Very nice. Very large.",
         "length": 43,
         "handle": "amethyst-ring-7"
      }
   ],
   "4687185838164": [
      {
         "nickname": "Reha L.",
         "review": "Even more beautiful in real life! I love it",
         "length": 43,
         "handle": "crescent-moon-necklace"
      },
      {
         "nickname": "Zaira F.",
         "review": "Each piece that I ordered is so beautiful. Thank you! 💛",
         "length": 56,
         "handle": "crescent-moon-necklace"
      },
      {
         "nickname": "Savannah B.",
         "review": "It came so quickly and it matches a ton of my other jewelry.",
         "length": 60,
         "handle": "crescent-moon-necklace"
      },
      {
         "nickname": "andy S.",
         "review": "Was very fast to arrive and the packaging was so cute. Love it",
         "length": 62,
         "handle": "crescent-moon-necklace"
      },
      {
         "nickname": "Alyssa C.",
         "review": "So cute! Perfect material, perfect size, feels really high quality. I’m just so happy with it!",
         "length": 94,
         "handle": "crescent-moon-necklace"
      }
   ],
   "6612355317934": [
      {
         "nickname": "Julie C.",
         "review": "My daughter loved the necklaces. So unique.",
         "length": 43,
         "handle": "aura-heart-necklace"
      },
      {
         "nickname": "Sakeidra  C.",
         "review": "So cute , I love it. Got complements all night about my necklace ",
         "length": 65,
         "handle": "aura-heart-necklace"
      },
      {
         "nickname": "Anamarie O.",
         "review": "Perfect gift! Got two for my best friend and I! Simple and beautiful.",
         "length": 69,
         "handle": "aura-heart-necklace"
      },
      {
         "nickname": "Emily A.",
         "review": "super cute necklace! got it for my best friend and I and we both love them! gotten so many compliments too!!",
         "length": 108,
         "handle": "aura-heart-necklace"
      }
   ],
   "6263393484974": [
      {
         "nickname": "Aimee M.",
         "review": "It’s a true beauty, in love with this ring! ",
         "length": 44,
         "handle": "copy-of-moonstone-ring-1"
      },
      {
         "nickname": "Samantha d.",
         "review": "The prettiest ring and still so delicate looking! I love it!",
         "length": 60,
         "handle": "copy-of-moonstone-ring-1"
      },
      {
         "nickname": "Alivia C.",
         "review": "I was worried about the size but it fits so nicely and I love the way the light reflects off of it. I’m sooooooo in love and happy that I found this brand",
         "length": 154,
         "handle": "copy-of-moonstone-ring-1"
      }
   ],
   "4605772922964": [
      {
         "nickname": "Andrea C.",
         "review": "Perfect fit and beautiful design once again.",
         "length": 44,
         "handle": "crystal-arrow-bracelet"
      }
   ],
   "6952579498158": [
      {
         "nickname": "Myrka E.",
         "review": "This ring is so cute my girlfriend loved it <3",
         "length": 46,
         "handle": "crystal-stacker-ring"
      },
      {
         "nickname": "Mariana O.",
         "review": "Such a cute ring either for everyday or to match any outfit ! Very well made and beautiful :)",
         "length": 93,
         "handle": "crystal-stacker-ring"
      },
      {
         "nickname": "Caitlyn S.",
         "review": "So elegant and pretty! Works well to stack with other rings. Quality is astoundingly beautiful.",
         "length": 95,
         "handle": "crystal-stacker-ring"
      }
   ],
   "6612576829614": [
      {
         "nickname": "Annabella M.",
         "review": "The necklace is so cute and super good quality",
         "length": 46,
         "handle": "envelope-locket-necklace"
      },
      {
         "nickname": "audrey h.",
         "review": "Found y’all through tiktok ad! Love the necklace so much!",
         "length": 57,
         "handle": "envelope-locket-necklace"
      },
      {
         "nickname": "Joy S.",
         "review": "I loved it so much, had to wait for it to come back but it’s perfect ",
         "length": 69,
         "handle": "envelope-locket-necklace"
      },
      {
         "nickname": "Nadica T.",
         "review": "The necklace came in fast and it's so beautiful! The locket opens easily and is secure when you close it. 10/10",
         "length": 111,
         "handle": "envelope-locket-necklace"
      },
      {
         "nickname": "Caden L.",
         "review": "It's so so adorable and I can tell its gonna stand the test of time! My only issue is that the necklace has a lil slot at the top even when closed that allows whatever is inside to slip out occasionally. Other than that I love it",
         "length": 229,
         "handle": "envelope-locket-necklace"
      },
      {
         "nickname": "Aide P.",
         "review": "It's very good quality I'm going to give it to my mom as her b-day present. (Shell not included I made it myself lol) you can tell it will last her a long time. I love how the necklace has tiny reflective parts so it's not a plain chain. Just be careful to not put anything to slim because it can slide out from the top so it's best to fold your picture/note :)",
         "length": 361,
         "handle": "envelope-locket-necklace"
      },
      {
         "nickname": "megan m.",
         "review": "I ordered this envelope locket in addition to their leaf ring and am now obsessed with this shop, everything is beautifully crafted and so well put together. The chain is dainty but sturdy enough for everyday wear and the locket is so unique. The details are incredible from the cute little flowers imprinted into the envelope to the tiny block accents on the chain. I have been wearing this daily since I got it and it hasn’t tarnished or anything. The locket itself is small enough for me to keep a personal fortune folded up in to have with me everyday. It came in a soft purple pouch that’s perfect for storage. Thank you so much!!",
         "length": 635,
         "handle": "envelope-locket-necklace"
      }
   ],
   "6620880699566": [
      {
         "nickname": "Erica B.",
         "review": "Super cute cuff and great Mother’s Day present!",
         "length": 47,
         "handle": "amethyst-stalactite-cuff-10"
      }
   ],
   "7367287013550": [
      {
         "nickname": "Sara B.",
         "review": "Awesome product! Can’t wait for my next order ❤️",
         "length": 48,
         "handle": "amethyst-stalactite-cuff-10"
      }
   ],
   "7465944613097": [
      {
         "nickname": "Jessica K.",
         "review": "LOVE LOVE LOVE! Easy to order and fast shipping!",
         "length": 48,
         "handle": "geode-box-94"
      }
   ],
   "7247066529966": [
      {
         "nickname": "Ashley D.",
         "review": "My sister loved the necklace! Excellent quality.",
         "length": 48,
         "handle": "cosmic-butterfly-necklace"
      }
   ],
   "6288009789614": [
      {
         "nickname": "MARGOT H.",
         "review": "I will definitely order more! Totally recommend!",
         "length": 48,
         "handle": "north-star-ear-huggies-1"
      },
      {
         "nickname": "Holly B.",
         "review": "Really cute earrings, exactly what I was looking for! Quick shipping and very cute packaging!",
         "length": 93,
         "handle": "north-star-ear-huggies-1"
      }
   ],
   "7305300476078": [
      {
         "nickname": "tania c.",
         "review": "necklace is beautiful and super fast shipping :)",
         "length": 48,
         "handle": "ethereal-love-necklace"
      }
   ],
   "2418265653332": [
      {
         "nickname": "Ariana M.",
         "review": "Loved the items! Such great quality and delivery",
         "length": 48,
         "handle": "rhodochrosite-pocket-stone"
      }
   ],
   "4490095001684": [
      {
         "nickname": "Debra G.",
         "review": "Like them a lot and they are crafted really well.",
         "length": 49,
         "handle": "amethyst-halo-hoops-silver"
      }
   ],
   "5926314999982": [
      {
         "nickname": "Maliya C.",
         "review": "Absolutely love it perfect size and very beautiful",
         "length": 50,
         "handle": "smoky-quartz-essential-oil-perfume-bottle-necklace"
      }
   ],
   "6077020635310": [
      {
         "nickname": "Marie P.",
         "review": "Wonderfull, i love it so much, thank’s from Paris !",
         "length": 51,
         "handle": "copy-of-opal-loop-ring"
      },
      {
         "nickname": "Ellie S.",
         "review": "I love this ring so much it fits really well and is super nice quality !!",
         "length": 73,
         "handle": "copy-of-opal-loop-ring"
      },
      {
         "nickname": "Carol-Ann M.",
         "review": "Beautiful packaging and fast delivery to UK. Met beyond expectations, I love it!",
         "length": 80,
         "handle": "copy-of-opal-loop-ring"
      },
      {
         "nickname": "Haruka O.",
         "review": "The ring is absolutely stunning and I love it. I think the resizable option is AMAZING because it fits more than one finger!",
         "length": 124,
         "handle": "copy-of-opal-loop-ring"
      }
   ],
   "6797796507822": [
      {
         "nickname": "Lisa P.",
         "review": "I love my purchase! It is so magical and beautiful :)",
         "length": 53,
         "handle": "geode-box-15"
      }
   ],
   "6596766531758": [
      {
         "nickname": "Jessica W.",
         "review": "I love this necklace! Such a unique and pretty design!",
         "length": 54,
         "handle": "opal-star-necklace-gold"
      }
   ],
   "4766586011732": [
      {
         "nickname": "katie  .",
         "review": "Holding well together after a couple days. Very pretty.",
         "length": 55,
         "handle": "agate-phone-grip-2"
      }
   ],
   "6616680661166": [
      {
         "nickname": "Sydney L.",
         "review": "I love it! It goes so well with the cherry blossom ring!",
         "length": 56,
         "handle": "crystal-branch-ring-1"
      },
      {
         "nickname": "Caitlyn S.",
         "review": "Absolutely beautiful! I want more! Pairs well with any outfit. Wonderful quality!",
         "length": 81,
         "handle": "crystal-branch-ring-1"
      },
      {
         "nickname": "Ashley D.",
         "review": "Very cutee and comfortable. I wasn’t sure on my ring size but I got a size 5 and it fits perfect! Love how shiny it looks under the sun.",
         "length": 136,
         "handle": "crystal-branch-ring-1"
      },
      {
         "nickname": "Dadrian A.",
         "review": "She absolutely loved it, ring sizes matched up which was the most worrying part when buying off websites, 10/10 recommend to get your jewelry from here. ",
         "length": 153,
         "handle": "crystal-branch-ring-1"
      },
      {
         "nickname": "megan m.",
         "review": "I absolutely love the jewelry I recieved from this shop, this is my first time buying nice pieces for myself and they did not disappoint. I have been wearing this ring everyday since I got it and it has not tarnished at all, the gems are set sturdy in the ring so I’m not worried about them coming loose either. Additionally the packaging was super cute and thoughtfully put together, my ring came in a beautiful, purple velvet, hexagon box that I keep it in while I sleep or shower and they included a polishing cloth as well. I definitely will be ordering more soon!",
         "length": 568,
         "handle": "crystal-branch-ring-1"
      }
   ],
   "6295632117934": [
      {
         "nickname": "Janine V.",
         "review": "Beautiful little box. I cannot wait to give it as a gift.",
         "length": 57,
         "handle": "geode-box-2"
      }
   ],
   "6016869630126": [
      {
         "nickname": "Taylor R.",
         "review": "The necklace is beautiful! I would 10/10 recommend ordering.",
         "length": 60,
         "handle": "bee-necklace"
      },
      {
         "nickname": "Jordan J.",
         "review": "This bee necklace was apart of my second order from Serendipity. I saw it a while ago and knew that I had to have it. I think of it as a symbol for my dog Bianca who I call Bibi. With this necklace it is like she is always with me.",
         "length": 231,
         "handle": "bee-necklace"
      },
      {
         "nickname": "Zaira F.",
         "review": "This was my first time purchasing from this small business & I’m so glad I did—I love it! Each item that I ordered is stunning & arrived on time & the packaging is really cute. Overall, a very happy customer & will be ordering again from this business, soon ❤️",
         "length": 260,
         "handle": "bee-necklace"
      },
      {
         "nickname": "Virginia D.",
         "review": "I chose the wrong one so I send a mail to the seller and she send me the right one. She’s really nice. The quality is great and it’s so so pretty. Would recommend. But it came with many knots, so it would be great if she would use some cards or something to hold it in place while it travels. ",
         "length": 293,
         "handle": "bee-necklace-dainty-stamp-design"
      }
   ],
   "7272440103086": [
      {
         "nickname": "Marissa R.",
         "review": "Just really lobed how everything was tbh especially the care.",
         "length": 61,
         "handle": "birth-flower-necklace"
      },
      {
         "nickname": "Sabrina G.",
         "review": "I bought this beautiful necklace and a pair of earring for my nieces birthday she absolutely loves the jewelry! 😍",
         "length": 114,
         "handle": "birth-flower-necklace"
      }
   ],
   "6600604319918": [
      {
         "nickname": "Marina L.",
         "review": "Its so nice! Just opening the velvet package i felt so fancy!",
         "length": 61,
         "handle": "garnet-stardew-ring-dainty-gemstone-ring"
      },
      {
         "nickname": "Vanessa  G.",
         "review": "It is now my favorite ring and can’t go without it (: thank you so much!",
         "length": 72,
         "handle": "garnet-stardew-ring"
      },
      {
         "nickname": "Zafirah A.",
         "review": "Beautiful ring! Great quality and fast international shipping. Thank you! x",
         "length": 75,
         "handle": "garnet-stardew-ring"
      },
      {
         "nickname": "Adam Mars L.",
         "review": "Great quality jewelry for a great price. My girlfriend loves the ring! I’m definitely going to be buying from this shop again.",
         "length": 126,
         "handle": "garnet-stardew-ring-dainty-gemstone-ring"
      },
      {
         "nickname": "Julianne S.",
         "review": "It’s a beautiful piece! It shipped fast and was packaged nicely. The gem is on the smaller side but it still looks great nonetheless.",
         "length": 133,
         "handle": "garnet-stardew-ring"
      },
      {
         "nickname": "Rachel J.",
         "review": "I found this store on Instagram and immediately fell in love! The quality of their product is outstanding, and the amount of care they put into packaging their jewelry is above and beyond.",
         "length": 188,
         "handle": "garnet-stardew-ring-dainty-gemstone-ring"
      }
   ],
   "6313381396654": [
      {
         "nickname": "Duncan N.",
         "review": "Bought it for my girlfriend and she loves it so I love it to.",
         "length": 61,
         "handle": "gemstone-essential-oil-bottle-necklace"
      },
      {
         "nickname": "Ariane S.",
         "review": "I got this item for my mother for Mother’s Day and she absolutely loved it!!! Would get again !",
         "length": 95,
         "handle": "gemstone-essential-oil-bottle-necklace"
      },
      {
         "nickname": "Sabrina S.",
         "review": "Great customer service, great products! You pay for quality and you get it, I’ll definitely be a repeat customer.",
         "length": 113,
         "handle": "gemstone-essential-oil-bottle-necklace"
      },
      {
         "nickname": "Autumn C.",
         "review": "So I originally ordered the shape above but they were sold out but they contacted me right telling me what options I had and I am so happy with my purchase!!!",
         "length": 158,
         "handle": "gemstone-essential-oil-bottle-necklace"
      }
   ],
   "6596810277038": [
      {
         "nickname": "Laurine  .",
         "review": "a beautiful gift for a friend of mine, very fine and original",
         "length": 61,
         "handle": "grape-ear-huggies"
      }
   ],
   "6077116022958": [
      {
         "nickname": "Sabrina  L.",
         "review": "Another pretty picture. \nMust see it for yourself in person!💜",
         "length": 62,
         "handle": "moonstone-halo-ring"
      },
      {
         "nickname": "Jennifer C.",
         "review": "Absolutely beautiful ring and wonderful service from Serendipity \n",
         "length": 66,
         "handle": "moonstone-halo-ring"
      },
      {
         "nickname": "Katia A.",
         "review": "BEAUTIFUL RING!! Shipping was super quick and the ring fits perfectly! 10/10. Will definitely shop here again!",
         "length": 110,
         "handle": "moonstone-halo-ring"
      },
      {
         "nickname": "Jessica S.",
         "review": "Love this ring! It sparkles beautifully, definitely an eye catcher. I get compliments left and right AND it does NOT turn your finger green. 10/10 recommend. ",
         "length": 158,
         "handle": "moonstone-halo-ring"
      },
      {
         "nickname": "Brianna D.",
         "review": "LOVE my ring so much. I would leave a picture but my nails are hideous right now. it fits perfectly and looks amazing with my other rings on. the only issue is the stone likes to move? I don’t know if it’s just loose or it’s suppose to be like that, but i highly recommend!! ",
         "length": 275,
         "handle": "moonstone-halo-ring"
      },
      {
         "nickname": "Lexi M.",
         "review": "I’m being completely honest I literally love this brand and the ring is stunning and worth the price, everything is so pretty from the ring to the packaging. The packaging is pretty nice too it’s supportive so the jewelry doesn’t move and break and it’s a unique purple and I also like that it came with a cloth to clean it. So overall I would absolutely recommend ",
         "length": 365,
         "handle": "moonstone-halo-ring"
      },
      {
         "nickname": "Sabrina  L.",
         "review": "This ring is so much prettier in person! Pictures just don’t do it justice.  It took my breath away when I opened it! \nI ordered the wrong size and they were happy to exchange it for the right size! I have been looking for a moonstone ring for quite sometime now. I couldn’t be more happier! 💜\nIf you’re on the fence about purchasing, jump off and just buy it! You won’t regret it!💜💜💜",
         "length": 388,
         "handle": "moonstone-halo-ring"
      }
   ],
   "6292007157934": [
      {
         "nickname": "Selma S.",
         "review": "My experience was great! Good website and beautiful jewellery.",
         "length": 62,
         "handle": "victorian-locket-necklace"
      },
      {
         "nickname": "Sabrina  L.",
         "review": "After purchasing the halo moonstone ring, I decided to buy again, the heat locket. \nI am loving the chain on this heart locket. So pretty💜\nI bought my sister one for Christmas too. \nAnother happy Purchase!💜",
         "length": 208,
         "handle": "victorian-locket-necklace"
      }
   ],
   "6559986253998": [
      {
         "nickname": "Angela S.",
         "review": "Beautiful ring! It’s my favorite and I can’t wait to get more!",
         "length": 62,
         "handle": "amethyst-ring-8"
      }
   ],
   "6077108748462": [
      {
         "nickname": "Andrea H.",
         "review": "Loved it get so many compliments on it all the time Super cute",
         "length": 62,
         "handle": "copy-of-snowflake-natural-gemstone-ring"
      },
      {
         "nickname": "Zafirah A.",
         "review": "Absolutely love this ring! The design is stunning and love how it is adjustable to accommodate a wide range of sizes!",
         "length": 117,
         "handle": "copy-of-snowflake-natural-gemstone-ring"
      },
      {
         "nickname": "Vanessa  G.",
         "review": "It’s better than what I expected. Quality is great and it’s so much prettier than the photos online. Thank you again (:",
         "length": 119,
         "handle": "copy-of-snowflake-natural-gemstone-ring"
      },
      {
         "nickname": "Juliann S.",
         "review": "The ring is beautiful, just like in the picture, so far it’s my favorite ring! I wish I could have bought more, hopefully in the future as well. I got the velvet box as well, super cute! ",
         "length": 187,
         "handle": "copy-of-snowflake-natural-gemstone-ring"
      },
      {
         "nickname": "Michelle",
         "review": "I absolutely love this ring! I’ve been eyeing everything in this site but finally caved for this ring and I have no regrets, it’s stunning and I love that it’s adjustable. The colors and detailing are amazing. Definitely my favorite ring, I cannot stop looking at it!",
         "length": 267,
         "handle": "copy-of-snowflake-natural-gemstone-ring"
      },
      {
         "nickname": "Jasmine G.",
         "review": "I was gifted the ring as an anniversary gift. Prior to receiving the ring, I stumbled upon the shop and I really liked the quality of everything so I did purchase a geode necklace for myself and my boyfriend knew how much I wanted another piece of jewelry, so for our anniversary he bought me a ring from the new collection. I’m absolutely in love with it and garnet just so happens to be my birth stone, I seriously can’t help but to admire it every chance I get. ",
         "length": 465,
         "handle": "copy-of-snowflake-natural-gemstone-ring"
      }
   ],
   "6616675156142": [
      {
         "nickname": "Sydney L.",
         "review": "I love my ring! It's so cute, light, and the size fit perfectly!",
         "length": 64,
         "handle": "sakura-ring"
      },
      {
         "nickname": "Jose V.",
         "review": "I love it. The rings are spectacular and so sparkly. Would 100% recommend.",
         "length": 74,
         "handle": "sakura-ring"
      },
      {
         "nickname": "Tiffany J.",
         "review": "Ring size fits perfect , it’s  to heavy. i love it! Shipping was quick with no issues. \n",
         "length": 88,
         "handle": "sakura-ring"
      },
      {
         "nickname": "Kaeshelle F.",
         "review": "I absolutely love it! It is so adorable! I have gotten a lot of compliments on it from friends.",
         "length": 95,
         "handle": "sakura-ring"
      }
   ],
   "4467303153748": [
      {
         "nickname": "Anita R.",
         "review": "This is such a gorgeous way to carry aroma therapy oil on the go.",
         "length": 65,
         "handle": "amazonite-essential-oil-perfume-bottle-necklace"
      }
   ],
   "6263416029358": [
      {
         "nickname": "Willow R.",
         "review": "Absolutely love this piece I've worn it every day since getting it",
         "length": 66,
         "handle": "pandora-ring"
      }
   ],
   "6985258107054": [
      {
         "nickname": "Robin  S.",
         "review": "These earrings are gorgeous. My daughter was very happy with them.",
         "length": 66,
         "handle": "celestial-moon-ear-huggies"
      }
   ],
   "6557802856622": [
      {
         "nickname": "Jacqueline  M.",
         "review": "It’s a very elegant bracelet and I am very happy with my purchase!",
         "length": 66,
         "handle": "floral-band-bracelet"
      }
   ],
   "6710858449070": [
      {
         "nickname": "Kenny M.",
         "review": "Love the work that was put into making it and how fast shipping was",
         "length": 67,
         "handle": "celestial-moon-necklace-with-opal"
      },
      {
         "nickname": "Dana P.",
         "review": "so pretty! this necklace was reasonably priced and shipped quickly. It looks great and is a nice size and is perfect for anyone. I would highly recommend this store and this necklace!",
         "length": 183,
         "handle": "celestial-moon-necklace-with-opal"
      },
      {
         "nickname": "Vanessa J.",
         "review": "I’m Obsessed!! I’m Sorry I Don’t Have A Good Pic But I Am Absolutely Going To Take One And Post It To Instagram! I Only Take Mine Off To Shower, It’s Gorgeous And I Get So Many Compliments! ",
         "length": 190,
         "handle": "celestial-moon-necklace-with-opal"
      }
   ],
   "4467886456916": [
      {
         "nickname": "Amanda K.",
         "review": "It’s beautiful and perfect! I will be wearing this probably everyday",
         "length": 68,
         "handle": "amethyst-essential-oil-perfume-bottle-necklace-1"
      },
      {
         "nickname": "Zaira F.",
         "review": "So beautiful & arrived just in time for a birthday gift to my sister. Thank you! 💜",
         "length": 83,
         "handle": "amethyst-essential-oil-perfume-bottle-necklace-1"
      },
      {
         "nickname": "Esther V.",
         "review": "It took a bit longer than expected due to corona b5+'¿ jijijiji but it arrived safe and sound =)\n\nLove it and hope you have more of these lovely necklaces",
         "length": 154,
         "handle": "amethyst-essential-oil-perfume-bottle-necklace-1"
      },
      {
         "nickname": "Jasmine H.",
         "review": "I’m in love with this necklace! It’s beautiful, the perfect length and size. The material is durable and of wonderful quality as well as the Amethyst and the dropper that is included. The packaging was beautiful as well, thank you.",
         "length": 231,
         "handle": "amethyst-essential-oil-perfume-bottle-necklace-1"
      }
   ],
   "6262996893870": [
      {
         "nickname": "J. G.",
         "review": "It’s a bit smaller then I had in mind, but it’s absolutely gorgeous. ",
         "length": 69,
         "handle": "opal-star-necklace-1"
      },
      {
         "nickname": "Kurtisha H.",
         "review": "Gave this necklace as a gift to my boyfriends mom, apparently it left it great impression. I'm so thankful I came across the tiktok page. Happy to support and also gift something that was appreciated. ",
         "length": 201,
         "handle": "petite-opal-star-necklace"
      },
      {
         "nickname": "Brooke R.",
         "review": "I loved how fast my necklace got to me and I loved how it looked in person. Everytime I wear it, I almost get crossed eyed from looking down at it because it's beautiful. I have been following this brand on Instagram for 2 years and I finally purchased something and it was one of the best purchases I've made.",
         "length": 310,
         "handle": "petite-opal-star-necklace"
      }
   ],
   "6077745463470": [
      {
         "nickname": "Laurie O.",
         "review": "I loved the piece itself and especially the way the ring was packaged.",
         "length": 70,
         "handle": "citrine-ring-natural-gemstone-rose-gold"
      },
      {
         "nickname": "Danielle B.",
         "review": "It is so lovely I adore it, 1 thing to think of for buyers. It was sliiightly smaller than anticipated but still well worth the price. ",
         "length": 135,
         "handle": "citrine-ring"
      }
   ],
   "4733887053908": [
      {
         "nickname": "Samantha H.",
         "review": "I love my crystal agate phone grip!! It’s super cute and not too heavy!",
         "length": 71,
         "handle": "crystal-agate-phone-grip-2"
      }
   ],
   "6547320373422": [
      {
         "nickname": "JJ V.",
         "review": "Very pretty ring, i love it and definitely would buy more rings from here. ",
         "length": 75,
         "handle": "natural-gemstone-amethyst-stardew-ring"
      },
      {
         "nickname": "Johann J.",
         "review": "My girlfriend loved it! The photos don't do it justice. 10/10 in person, great buy",
         "length": 82,
         "handle": "amethyst-stardew-ring"
      }
   ],
   "4705146437716": [
      {
         "nickname": "Sandy",
         "review": "I love how this necklace sparkles. I've been wearing it every day. Love it!",
         "length": 75,
         "handle": "crescent-moon-opal-necklace"
      }
   ],
   "6279610826926": [
      {
         "nickname": "Carol-Ann M.",
         "review": "Amazing quality and looks beautiful! Packaging was perfect and fast delivery",
         "length": 76,
         "handle": "galaxy-necklace-set-1"
      }
   ],
   "6612709540014": [
      {
         "nickname": "MARGOT H.",
         "review": "We're gorgeous, I really love them. Can't wait to order again from you guys! ",
         "length": 77,
         "handle": "lighting-bolt-ear-huggies"
      }
   ],
   "7252118995118": [
      {
         "nickname": "Carolina A.",
         "review": "It came really fast and it's as the description and pictures show! I love it!",
         "length": 77,
         "handle": "copy-of-cluster-necklace"
      }
   ],
   "4638789599316": [
      {
         "nickname": "Andrea C.",
         "review": "Beautiful design, wish it were real crystal but I love them they're perfect.\n",
         "length": 77,
         "handle": "emerald-crystal-halo-hoops"
      }
   ],
   "6263069376686": [
      {
         "nickname": "Ana D.",
         "review": "Super cute, I bought it for my self and definitely will buy more my love ones. 💖",
         "length": 81,
         "handle": "crystal-butterfly-necklace"
      }
   ],
   "6704940187822": [
      {
         "nickname": "Estefania’s P.",
         "review": "I was so surprised by the quality of the product but it fit great looked amazing.",
         "length": 81,
         "handle": "cosmo-ring"
      },
      {
         "nickname": "Julie N.",
         "review": "This is a beautiful ring! I love astronomy and I even have stars and constellation tattoos! I was looking for a gold star ring and this popped up on my FYP on TikTok and I ordered it!! Couldn't be happier.",
         "length": 205,
         "handle": "cosmo-ring"
      }
   ],
   "6547352060078": [
      {
         "nickname": "Olivia B.",
         "review": "I love my new ring soooo soso much! Ill be recommending this company to everyone!!",
         "length": 82,
         "handle": "opal-loop-ring-1"
      },
      {
         "nickname": "Amber B.",
         "review": "Bought matching rings for my best friend and me as a wedding keepsake and I could not be happier! It's dainty yet sturdy and I just know she's going to love it",
         "length": 159,
         "handle": "opal-loop-ring-1"
      }
   ],
   "6704973676718": [
      {
         "nickname": "Mariana O.",
         "review": "Such a beautifully made product !!! Such a sweet addition to my everyday jewelry !!!",
         "length": 84,
         "handle": "opal-cluster-stud"
      }
   ],
   "4739175383124": [
      {
         "nickname": "Maria M.",
         "review": "LOVE LOVE LOVE- THE OWNER IS SO TALENTED I HIGHLY RECOMEND GOT COMPLIMENTS ALL NIGHT",
         "length": 84,
         "handle": "agate-ring"
      }
   ],
   "4673538719828": [
      {
         "nickname": "Liberty  M.",
         "review": "This bracelet was so cute! And it matched great with the cute outfits I had in mind.",
         "length": 84,
         "handle": "sun-brushed-necklace"
      }
   ],
   "7148872138926": [
      {
         "nickname": "Katie R.",
         "review": "The most beautiful high quality jewellery, incredible packaging. Absolutely in love ",
         "length": 84,
         "handle": "opal-star-studs"
      }
   ],
   "6084463263918": [
      {
         "nickname": "Emma S.",
         "review": "I adore all the jewelry you have! It’s all so pretty and can be worn for any occasion",
         "length": 85,
         "handle": "opal-crescent-moon-hoops-dainty-gold-earrings"
      },
      {
         "nickname": "Sammy G.",
         "review": "I absolutely love them ! They look so cute in the sunlight and literally go with everything! I’m so glad I got them. :)",
         "length": 119,
         "handle": "opal-crescent-moon-hoops"
      },
      {
         "nickname": "Louis E.",
         "review": "these earrings are so beautiful in the picture AND in real life. I love them & I think my sis is gonna love them even more!",
         "length": 123,
         "handle": "opal-crescent-moon-hoops"
      },
      {
         "nickname": "Giselle V.",
         "review": "Absolutely loved these earrings ! They were the perfect size for me ! Nothing too big or bothersome , just perfect and so cute ! ",
         "length": 129,
         "handle": "opal-crescent-moon-hoops-dainty-gold-earrings"
      }
   ],
   "6275279323310": [
      {
         "nickname": "Yulia S.",
         "review": "Got so many compliments on this gorgeous piece from men and women and children !!! Wow",
         "length": 86,
         "handle": "black-tourmaline-ring-8"
      }
   ],
   "4667656896596": [
      {
         "nickname": "Amanda R.",
         "review": "Could not be happier with my new necklace and opal earring huggies.  They're beautiful 😍",
         "length": 89,
         "handle": "opal-evil-eye-necklace"
      },
      {
         "nickname": "Aubrey S.",
         "review": "This is such a beautiful necklace! I received it as a birthday gift and wowwww I am in love, it paired so nice over my other gold necklaces I wear everyday. Thank you sister. \nIt does feel heavy ish which I love! it feels expensive and durable !! ",
         "length": 247,
         "handle": "opal-evil-eye-necklace"
      }
   ],
   "6264733663406": [
      {
         "nickname": "Kaeshelle F.",
         "review": "Super cute! I have been eyeing these earrings for awhile and I am so happy I bought them.",
         "length": 89,
         "handle": "star-ear-huggies"
      },
      {
         "nickname": "Anya H.",
         "review": "these are the most beautiful earrings ever! i never take them off :) they’re my favorite piece of jewelry i have right now",
         "length": 122,
         "handle": "star-ear-huggies"
      },
      {
         "nickname": "Hanna S.",
         "review": "Great hinges, neither too thick or thin. Super lightweight but felt very secure. Will absolutely compliment any outfit or hair. Also, they came just in time for my party I was hosting and I got a ton of compliments on them.",
         "length": 223,
         "handle": "star-ear-huggies"
      }
   ],
   "4708796596308": [
      {
         "nickname": "Jasmine G.",
         "review": "Lovely necklace, this was my first purchase from the shop and most certainly not my last ",
         "length": 89,
         "handle": "amethyst-stalactite-necklace-12"
      }
   ],
   "4687062368340": [
      {
         "nickname": "Kayla T.",
         "review": "Perfect size! Love a good timeless piece to wear with anything! Very pleased with my purchase!",
         "length": 94,
         "handle": "rose-necklace"
      },
      {
         "nickname": "Sydney M.",
         "review": "Love the look of it and the length is great for layering. I polish it after each wear to keep it from tarnishing.",
         "length": 113,
         "handle": "rose-necklace"
      }
   ],
   "7453088874729": [
      {
         "nickname": "Ginna C.",
         "review": "Me encanto mi joyero de viaje, tiene tamaño perfecto para llevar lo esencial. Muchas gracias!!!",
         "length": 95,
         "handle": "traveling-jewelry-case"
      }
   ],
   "6601685631150": [
      {
         "nickname": "Karla M.",
         "review": "This ring exceeded my expectations it’s very pretty and cute and looks amazing in any lighting!",
         "length": 95,
         "handle": "floral-amethyst-ring-dainty-rose-gold-ring"
      }
   ],
   "6612693319854": [
      {
         "nickname": "Andrea R.",
         "review": "Such cute packaging. Delivery took wayy longer than expected but it is a very beautiful necklace",
         "length": 96,
         "handle": "opal-moon-necklace-2"
      },
      {
         "nickname": "Brianna T.",
         "review": "Great! took a little to ship to Canada. but super satisfied with the products when they arrived!\n",
         "length": 97,
         "handle": "opal-moon-necklace-2"
      }
   ],
   "4612213375060": [
      {
         "nickname": "Ashley D.",
         "review": "A little smaller than expected, but good quality and coloring. Would definitely buy another one. ",
         "length": 97,
         "handle": "large-smoky-quartz-point"
      }
   ],
   "6263393812654": [
      {
         "nickname": "autumn m.",
         "review": "i luved it ! it was super cute and the chain is dainty it really fit the aesthetic of the crystals",
         "length": 98,
         "handle": "star-baguette-necklace"
      },
      {
         "nickname": "Leah G.",
         "review": "Bought this necklace for my moms birthday and she loves it. Really fast shipping too! Very impressed! ⭐️⭐️⭐️⭐️⭐️",
         "length": 112,
         "handle": "star-baguette-necklace"
      },
      {
         "nickname": "Kurtisha H.",
         "review": "Beautiful and fast shipping. I gave this necklace as a gift but now I certainly will purchase a piece for myself. Love the detail and background story of the designer. Keep up the fantastic work creators!!",
         "length": 205,
         "handle": "star-baguette-necklace"
      },
      {
         "nickname": "Sierra D.",
         "review": "I bought the necklace as a mother's day gift. My parents are retiring and moving to the beach soon, and my mom loves starfish so I thought this necklace was perfect. My mom loves it and she's a very picky jewelry wearer!",
         "length": 220,
         "handle": "star-baguette-necklace"
      },
      {
         "nickname": "fay m.",
         "review": "I bought this necklace as a graduation gift for my girlfriend. It took a little while to get there but the packaging was beautiful and she's obsessed with the necklace. She loves the length and is obsessed with the way the diamonds catch and hold the light. 100/10 I can't recommend it enough.",
         "length": 293,
         "handle": "star-baguette-necklace"
      }
   ],
   "7392560545966": [
      {
         "nickname": "Morgan M.",
         "review": "This is like my fifth pair of earring from here. Can’t stop! And my sensitive ears don’t mind them.",
         "length": 99,
         "handle": "stellar-triad-studs"
      },
      {
         "nickname": "Farisai M.",
         "review": "These are the most beautiful and feather light earrings I have ever purchased,I'm definitely coming for more",
         "length": 108,
         "handle": "stellar-triad-studs"
      },
      {
         "nickname": "Marisol M.",
         "review": "This is the third pair of earrings from here that I own and I am IN LOVE. They just go with everything and I simply love a dainty look.",
         "length": 135,
         "handle": "stellar-triad-studs"
      }
   ],
   "6016745275566": [
      {
         "nickname": "Lorena C.",
         "review": "A cute little necklace to spice up  my favorite outfits. Good quality and a quick delivery as well.",
         "length": 99,
         "handle": "flower-locket-necklace"
      },
      {
         "nickname": "Hanna S.",
         "review": "Very strong clasp for the locket which made me feel very secure that it wouldn’t pop open, as I had to work to get it open. A little smaller than perhaps I was looking for, but suited me well. The chain is super fine and delicate leaving me a little worried it might break with time, but the clasp also has good hardware and it would definitely have to break on the links. It’s also a shorter chain than I think I was expecting, but it ends up making me feel more secure that it’s less likely to catch on things and break the chain so I will be giving it 5 stars for beauty and security",
         "length": 586,
         "handle": "flower-locket-necklace"
      }
   ],
   "6274952560814": [
      {
         "nickname": "Ashley D.",
         "review": "The earrings are cute but I thought they would be bigger. Hopefully the person I gift it to loves them!",
         "length": 103,
         "handle": "petite-opal-star-ear-huggies"
      }
   ],
   "7356672770222": [
      {
         "nickname": "Isabelle P.",
         "review": "The flash on this stone is so pretty!! It's also bigger than I imagined which is amazing! I'm in love 🥰",
         "length": 104,
         "handle": "calisto-ring-the-round-ring"
      },
      {
         "nickname": "Kaleb  M.",
         "review": "Beautiful ring purchased for my girlfriend for Christmas. She will love it. Can’t wait to give it to her.",
         "length": 105,
         "handle": "calisto-ring-the-round-ring"
      },
      {
         "nickname": "Kelly G.",
         "review": "This ring in Mystic Topaz is gorgeous. I’ve never seen a mystic topaz stone quite like this one and I love it. Ring is very pretty design and well made.",
         "length": 152,
         "handle": "calisto-ring-the-round-ring"
      }
   ],
   "6712580505774": [
      {
         "nickname": "aiden B.",
         "review": "looks great would have included a photo but was a gift for my girlfriend, good size and love the quality",
         "length": 104,
         "handle": "celestial-halo-necklace-simply-dainty-style"
      },
      {
         "nickname": "Emi I.",
         "review": "I absolutely love this necklace! the photo does not do it justice. It looks like it was made out of sparkles. Would 100% recommend and buy again.",
         "length": 145,
         "handle": "celestial-halo-necklace-simply-dainty-style"
      }
   ],
   "6263407837358": [
      {
         "nickname": "amanda o.",
         "review": "The ring fits, looks great. I love the packaging. Earrings are adorable. Cute stuff I'll probably buy more",
         "length": 106,
         "handle": "deco-ring-natural-gemstone"
      }
   ],
   "6264735793326": [
      {
         "nickname": "Rebecca  W.",
         "review": "I absolutely love these earrings! They are even prettier than I was expecting. They are super great quality",
         "length": 107,
         "handle": "cubic-star-ear-huggies"
      }
   ],
   "6611069829294": [
      {
         "nickname": "Sabrina",
         "review": "These earrings are so cute. 🥺 They really make you feel like a magical girl. I can’t wait to purchase more!",
         "length": 108,
         "handle": "aura-heart-ear-huggies"
      }
   ],
   "4735734022228": [
      {
         "nickname": "Justina B.",
         "review": "It was really pretty bought it for my daughters birthday, a bit big but she did like it. Great green colour ",
         "length": 108,
         "handle": "agate-cuff-2"
      }
   ],
   "6600902246574": [
      {
         "nickname": "Haley B.",
         "review": "This locket is so cute! I love it! The only down side is it is smaller than I expected but it’s still perfect!",
         "length": 110,
         "handle": "galaxy-locket-necklace"
      }
   ],
   "7323772944558": [
      {
         "nickname": "Amanda B.",
         "review": "My necklace arrived VERY fast and came in the cutest package. It is very small and simple but still very elegant.",
         "length": 113,
         "handle": "stars-align-necklace"
      }
   ],
   "6262993387694": [
      {
         "nickname": "Sydney M.",
         "review": "Love it!!!! It’s super cute and I polish it after every wear to keep it from tarnishing. Get loads of compliments",
         "length": 113,
         "handle": "cubic-star-tag-necklace"
      }
   ],
   "6537581035694": [
      {
         "nickname": "Morgan M.",
         "review": "Perfect for everyday and even to sleep in. My ears are super sensitive and these are awesome at not irritating them.",
         "length": 116,
         "handle": "gold-star-ear-huggies"
      }
   ],
   "6867825262766": [
      {
         "nickname": "Mariana O.",
         "review": "My fave addition to my jewelry !!! I wore it twice and got compliments left right and centre those days . Love them !",
         "length": 117,
         "handle": "cascading-crystal-climber-earrings-for-everyday"
      }
   ],
   "6280201601198": [
      {
         "nickname": "Sara D.",
         "review": "I am obsessed with these earrings! They are my new favorite pair! I honestly want to buy so much more from here. Beautiful!",
         "length": 123,
         "handle": "galaxy-opal-hoops"
      }
   ],
   "6263407378606": [
      {
         "nickname": "Erin R.",
         "review": "The photo doesn’t do this gorgeous piece justice! In the sunshine, it’s spectacular!! And it fits so well! Highly recommend! ",
         "length": 125,
         "handle": "baguette-ring"
      }
   ],
   "4730148454484": [
      {
         "nickname": "Ashley W.",
         "review": "I love my pop socket! Shipping was super fast! Definitely will purchase from again! Perfect for a birthday or Christmas gift!",
         "length": 125,
         "handle": "crystal-agate-phone-grip"
      },
      {
         "nickname": "Amelia L.",
         "review": "Beautiful agate, such a cool unique pop socket. No fault of Serendipity, the joint of the pop socket is just too wobbly for my likes. Otherwise no other concerns, I get so many positive comments about how cool my popper is!",
         "length": 223,
         "handle": "crystal-agate-phone-grip"
      }
   ],
   "6313415639214": [
      {
         "nickname": "Ria O.",
         "review": "It’s a beautiful piece. The chain is very short however, just to be aware. But it’s beautiful and packaged really nicely too. ",
         "length": 126,
         "handle": "gemstone-point-essential-oil-bottle-necklace"
      },
      {
         "nickname": "Caitlyn S.",
         "review": "Beautiful necklace! I first saw Serendipity Jewelry on TikTok and was intrigued by the beautiful crystals and designs. This necklace truly stands out and is fully functional for storing essential oils! Great quality!! I would highly recommend :)",
         "length": 245,
         "handle": "gemstone-point-essential-oil-bottle-necklace"
      },
      {
         "nickname": "Chan A.",
         "review": "Received this piece as a gift from my wife and I love it. We’ve both made purchases before, but I was still amazed at how well the necklace suited me and compliments the items I bought before when layered. Definitely buying all the other colors ASAP. ",
         "length": 251,
         "handle": "gemstone-point-essential-oil-bottle-necklace"
      },
      {
         "nickname": "Fay  M.",
         "review": "I've been waiting months to buy this. My girlfriend has a sensitive nose and gets overwhelmed easily. I got this for her so when she's stressed she can calm down by focussing on the smell. she loves blue so I picked the lapis one. Absolute win, she loves it",
         "length": 257,
         "handle": "gemstone-point-essential-oil-bottle-necklace"
      }
   ],
   "4367358656596": [
      {
         "nickname": "Taylor R.",
         "review": "Super cute and dainty! Love it even more than I thought I would! The foiled look is so gorgeous and reflects in different light.",
         "length": 128,
         "handle": "jurassic-holo-necklace"
      }
   ],
   "4705150500948": [
      {
         "nickname": "Hana R.",
         "review": "It was exsactly what I was looking for and its absolutely beautiful. I love it so much and I can't wait to gift it to my grandma!!",
         "length": 130,
         "handle": "opal-crescent-moon-necklace-everyday-collection"
      },
      {
         "nickname": "Delainey T.",
         "review": "I was expecting this to be way bigger so I was a little nervous but it’s so beautiful! It’s small and dainty and the chain is just the right size. It’s very elegant overall. The stone shines with lots of rainbow colors and it’s gorgeous. I love it.",
         "length": 248,
         "handle": "opal-crescent-moon-necklace"
      }
   ],
   "7392534462638": [
      {
         "nickname": "Zhino",
         "review": "Just received my order and love it! I used the sizing guide on website and it's accurate. Looks really good and feels comfortable.",
         "length": 130,
         "handle": "baguette-ring"
      },
      {
         "nickname": "Ashley D.",
         "review": "Size 5: It’s not too big but thick on the sides which kind of annoys my fingers if I play with it too much. The sparkle is there !",
         "length": 130,
         "handle": "baguette-ring"
      }
   ],
   "6077114745006": [
      {
         "nickname": "Nick A.",
         "review": "Absolutely beautiful. I ordered these as a gift and I cannot wait to give them to my special someone. <3 Very happy with my purchase!",
         "length": 133,
         "handle": "snowflake-natural-gemstone-earrings"
      }
   ],
   "7392542556334": [
      {
         "nickname": "Ashley D.",
         "review": "Size 5: maybe a little tight after long wear and the edges are a rough against my fingers, but the shine from this ring is beautiful! ",
         "length": 134,
         "handle": "chain-ring"
      }
   ],
   "6713138774190": [
      {
         "nickname": "Abigail R.",
         "review": "The necklace was beautiful! It is very simple, but at the same time the stars are eye-catching. I get so many compliments when I wear it! ",
         "length": 138,
         "handle": "so-charmed-necklace"
      },
      {
         "nickname": "Virginia D.",
         "review": "It’s not as tight as the other necklaces from other shops, but it’s a good thing because it’s comfortable to wear. I put it with the other necklace to make it tighter to my neck and it looks incredible. The quality is nice too!! And I haven’t got any allergies !!",
         "length": 263,
         "handle": "so-charmed-necklace"
      }
   ],
   "4529352769620": [
      {
         "nickname": "Vanessa P.",
         "review": "I got these as a gift and they were so beautiful I forgot to take pics cause I sent them out so fast but I will definitely be getting more!",
         "length": 139,
         "handle": "lapis-lazuli-essential-oil-perfume-bottle-necklace"
      }
   ],
   "6952120811694": [
      {
         "nickname": "Marisa R.",
         "review": "I really liked and it and wore it everyday but unfortunately it already broke and I haven't had it for very long :( the hook on it broke off",
         "length": 140,
         "handle": "tennis-bracelet"
      }
   ],
   "7247069675694": [
      {
         "nickname": "Angela P.",
         "review": "Shipping was super fast and the packaging was soooo cute! Will definitely be buying more soon! The quality is ah-mazing!!! I’m so obsessed 😍\n",
         "length": 142,
         "handle": "opal-token-necklace"
      }
   ],
   "7392527646894": [
      {
         "nickname": "Sydney L.",
         "review": "I have the cherry blossom ring for myself and loved it so much that I got this ring for my sister! I'm excited to give it to her for Christmas!",
         "length": 143,
         "handle": "cosmic-infinity-band"
      }
   ],
   "4668660744276": [
      {
         "nickname": "Jamil C.",
         "review": "Lleve a mi novia por toda la isla ( Puerto Rico 🇵🇷 ) en una caravan!\nDesperto en la mañana con un rico desayuno y el anillo! \n\nDijo que SIII!!!",
         "length": 145,
         "handle": "free-standing-geode-box-53"
      }
   ],
   "4638217535572": [
      {
         "nickname": "Catherine  S.",
         "review": "this is one of my favorite necklaces! i fill it with citrus essential oil once a week and it smells like heaven. i highly recommend buying this :)",
         "length": 146,
         "handle": "rose-quartz-essential-oil-perfume-bottle-necklace-gold"
      }
   ],
   "6077112877230": [
      {
         "nickname": "Leonora A.",
         "review": "i bought it as a present for my mom and she absolutely loves it!! I could believe how pretty the pieces are irl and im definitely gonna order again!",
         "length": 148,
         "handle": "copy-of-snowflake-natural-gemstone-ring-1"
      }
   ],
   "7056153018542": [
      {
         "nickname": "Kristin F.",
         "review": "I am obsessed with this jewelry! Was looking for something dainty and elegant that wasn’t too expensive but still good quality and this hit the mark!",
         "length": 149,
         "handle": "alyssa-chain"
      }
   ],
   "6542457962670": [
      {
         "nickname": "Sara D.",
         "review": "This necklace is such a great layering and classic piece. Just what I was looking for. Great quality and great price! Will definitely be buying more!",
         "length": 149,
         "handle": "herringbone-chain"
      },
      {
         "nickname": "Kenia G.",
         "review": "I love this necklace quality is so good and I just love the classics of it. It’s my first piece but definitely not my last I also have the floral locket from here too",
         "length": 166,
         "handle": "herringbone-chain"
      }
   ],
   "6696813297838": [
      {
         "nickname": "Kelsey B.",
         "review": "This is my second geode box and I’m blown away again! I like the newer style of legs it has, they are soo beautiful!! Will definitely be buying more!! :) ",
         "length": 154,
         "handle": "geode-box-8"
      }
   ],
   "6263393091758": [
      {
         "nickname": "Perrine M.",
         "review": "Love this ring so much. The stone isn't too big which is amazing. The people behind the brand are lovely as well! I highly recommend everyone to buy! 🙌🏻🤍",
         "length": 156,
         "handle": "moonstone-ring-1"
      }
   ],
   "6283264360622": [
      {
         "nickname": "Brandon M.",
         "review": "Perfect size and showed up very fast. Been keeping my eye on them for around a year so jumped on ordering one when they were re-stocked. Very happy with it!",
         "length": 156,
         "handle": "free-standing-geode-box-12"
      }
   ],
   "6609128947886": [
      {
         "nickname": "Gloria C.",
         "review": "The ring is absolutely gorgeous! I get so many compliments on it. Shipping was quick, the packaging is beautiful. I will be coming back for more pieces soon!  ",
         "length": 159,
         "handle": "amethyst-halo-ring"
      }
   ],
   "6632966881454": [
      {
         "nickname": "Katia A.",
         "review": "This is my 2nd time ordering and the service is wonderful! The necklace is beautiful and the earrings are super comfortable! Definitely coming back a 3rd time!!",
         "length": 160,
         "handle": "stargazer-necklace"
      }
   ],
   "4735708921940": [
      {
         "nickname": "Aundreya G.",
         "review": "I saw this ring randomly scrolling through Instagram. The only full amethyst crescent moon ring they had. It was one of a kind and I just had to make it mine. ♡",
         "length": 160,
         "handle": "amethyst-crescent-moon-ring-1"
      }
   ],
   "6985425191086": [
      {
         "nickname": "Ashley D.",
         "review": "The earring are cute but again, I thought they would be bigger and probably in the sun they would look much prettier (the photos indoors aren’t the best quality)",
         "length": 161,
         "handle": "opal-solitaire-ear-huggies"
      }
   ],
   "6344060731566": [
      {
         "nickname": "Jacqueline  M.",
         "review": "Love these! I have been wanting earring like these for a while and I’m so happy I purchased them. My ears usually get irritated with earrings but not with these!",
         "length": 161,
         "handle": "crescent-moon-earrings-1"
      }
   ],
   "6263410819246": [
      {
         "nickname": "Cat D.",
         "review": "so delicate and beautiful. the only sad part is i got mustard on it and it stained the stones. I’d be careful with getting it dirty but other than that so worth it!!",
         "length": 165,
         "handle": "3-marquise-ring-in-amethyst"
      }
   ],
   "4667625439316": [
      {
         "nickname": "Sara B.",
         "review": "This necklace looks so beautiful and refined. I instantly fell in love with the design! I also love that it can be layered with other pieces and create a unique look",
         "length": 165,
         "handle": "opal-star-necklace"
      }
   ],
   "6596739268782": [
      {
         "nickname": "Kiyah H.",
         "review": "I love these earrings so much! I’ve been looking for earrings to wear every day that match my other body jewellery and I’m so glad that I purchased these earrings :)",
         "length": 165,
         "handle": "moon-and-star-ear-huggies"
      }
   ],
   "6537557934254": [
      {
         "nickname": "Janey J.",
         "review": "The jewelry is so lovely well made and beautifully crafted. And ...doesn’t cost a fortune. My “evil eye “ necklace sends all bad energy back to the sender. Lovely! Xxx",
         "length": 167,
         "handle": "evil-eye-heart-necklace"
      }
   ],
   "6262978412718": [
      {
         "nickname": "Sabrina",
         "review": "This locket is so gorgeous! It’s small but a noticeable piece! I love this in my collection. It’s so elegant. This would make such a special gift to someone you like. ❤️",
         "length": 169,
         "handle": "heart-locket-necklace-dainty-design"
      }
   ],
   "5926272368814": [
      {
         "nickname": "Paige M.",
         "review": "Love love love! I will note I have a case with the built in pop so I had to take mine apart and glue them to the newer version to work but it was no problem to do at all!",
         "length": 170,
         "handle": "agate-phone-grip-3"
      }
   ],
   "7287859347630": [
      {
         "nickname": "Xuan L.",
         "review": "Exactly as pictured, I've done a few comparisons and found this geodebox to be the best quality I can find in the market! It's sturdy in design and well cut! Absolutely pleased! ",
         "length": 178,
         "handle": "geode-box-52"
      }
   ],
   "7039366791342": [
      {
         "nickname": "Monica B.",
         "review": "So pretty! I ordered these online after seeing a reel on Instagram and just received them a few days ago. These are so beautiful and very dainty! Would definitely recommend them!",
         "length": 178,
         "handle": "opal-crescent-studs"
      }
   ],
   "7252271530158": [
      {
         "nickname": "Mina M.",
         "review": "I am starting to collect a little bit of everything from Serendipity! Such high quality jewelry and so much style! each piece is simple yet a statement! I will definitely recommend!",
         "length": 181,
         "handle": "let-light-in-necklace"
      }
   ],
   "7432569389289": [
      {
         "nickname": "Holly R.",
         "review": "Absolutely fell in love with the Milky Way Necklace. I’ve gotten so many compliments and it’s made me feel confident. It’s the perfect length and looks even better in person than I imagined.",
         "length": 190,
         "handle": "milky-way-necklace"
      }
   ],
   "3694615199828": [
      {
         "nickname": "Ashley D.",
         "review": "Reallllly cute and dainty and looks to be made with good quality. I’m not nervous the bracelet will break, as sometimes happens with dainty jewelry. Will purchase another one for my sister. ",
         "length": 190,
         "handle": "evil-eye-bracelet-1"
      }
   ],
   "6985478406318": [
      {
         "nickname": "Kayla L.",
         "review": "These earrings are absolutely gorgeous - I never take them off. They are so cute and aren’t too big and go w literally everything. I get compliments on them ALL the time. 10/10 would recommend",
         "length": 192,
         "handle": "opal-flower-ear-huggies"
      }
   ],
   "6288026501294": [
      {
         "nickname": "Carla H.",
         "review": "Absolutely stunning!!! Photos don’t do justice for these gorgeous earrings. The geodes have beautiful details in the stone and the druzy sparkle with every turn! Super excited to flaunt these!",
         "length": 192,
         "handle": "geode-studs-2"
      }
   ],
   "7356660351150": [
      {
         "nickname": "Torrence L.",
         "review": "I love my ring! It’s possibly the only piece of jewelry I will wear with citrine as I normally dislike my birthstone but this is just so pretty and perfect. It’s well made! Size is true to size.",
         "length": 194,
         "handle": "sun-ring"
      }
   ],
   "7439281422569": [
      {
         "nickname": "Else D.",
         "review": "I love this ring! I got it after my Dad passed away as a memorial. We were both moon signs. I love how significant it is and all the beautiful energy that comes from it when I wear it. It's perfect.",
         "length": 198,
         "handle": "fluorite-moon-ring-1"
      }
   ],
   "4728288575572": [
      {
         "nickname": "Salma F.",
         "review": "I love it. It’s very simple but still cute. I just recently discovered this website and I love her jewelry. I have to buy more. Also the packaging is amazing as well comes wrapped up neatly and nice.",
         "length": 199,
         "handle": "sapphire-evil-eye-necklace"
      }
   ],
   "4613302059092": [
      {
         "nickname": "Mia S.",
         "review": "Beautiful earrings! Simple yet super elegant. Delivered really fast. I had no problems at all. I'm gifting them to my best friend for Christmas; emerald green is her favorite color and these are just everything!",
         "length": 211,
         "handle": "emerald-crystal-earrings-1"
      }
   ],
   "7318693609646": [
      {
         "nickname": "Cat W.",
         "review": "I got this as a gift for my sister and man was it worth every penny!!!!! Absolutely so beautiful and the pictures do not do their products justice. I highly recommend this company. They have a forever customer here. ❤️",
         "length": 218,
         "handle": "geode-box-62"
      }
   ],
   "4762015301716": [
      {
         "nickname": "Saeid H.",
         "review": "What a lovely selection! Bought an item for my partner as a Christmas gift, and she absolutely loves it. Very unique, handcrafted, and beautiful selection of items; will be recommending them to practically everyone I know!",
         "length": 222,
         "handle": "compass-coin-necklace"
      }
   ],
   "4718596816980": [
      {
         "nickname": "Sima D.",
         "review": "Loved my jewellery pieces . They were very beautiful ❤️ Packaging was super cute and great customer service . Would definitely recommend to friends and family and will definitely shop again !  Thank you jewelery by serendipity 💜💜💜",
         "length": 233,
         "handle": "peach-drop-earrings"
      }
   ],
   "6617996001454": [
      {
         "nickname": "Sabrina",
         "review": "Beautiful little star necklace! Very dainty, more so than I had anticipated. My hands are quite small with my ring finger being a size 4 for reference! A beautiful, subtle but elegant, piece for my collection. Stars are my aesthetic. ",
         "length": 234,
         "handle": "aura-star-necklace-dainty-design"
      }
   ],
   "6350881652910": [
      {
         "nickname": "Danielle E.",
         "review": "Hi I have you linked in my IG bio I love them so much! I have ordered three times from them and have been so happy! amazing customer service and relationship with the buyer. So obsessed with this brand and everything they put out!! <3",
         "length": 234,
         "handle": "zodiac-coin-necklace"
      }
   ],
   "6659755901102": [
      {
         "nickname": "Zafirah A.",
         "review": "Gorgeous piece! Bought as a gift for a loved one and they loved it. Also comes with a mini dropper to transfer the oils into the bottle which is very handy. Loved all the items in my purchase, the quality is amazing would highly recommend!",
         "length": 239,
         "handle": "aura-quartz-essential-oil-perfume-bottle-necklace"
      }
   ],
   "6542318698670": [
      {
         "nickname": "Connors, M.",
         "review": "Absolutely love! Their Jewlery is so incredible, it's so cute and I love this type of earring back, so easy to use, no extra parts and incredibly comfortable. Highly recommend! These little moons give me all the dark magic/witchy vibes I want. So happy!",
         "length": 253,
         "handle": "crescent-moon-ear-huggies-1"
      }
   ],
   "6084645093550": [
      {
         "nickname": "Sabrina",
         "review": "Beautiful Saturn necklace! Very dainty and elegant. A must for your collection when you need something small, simple, and eye catching. I’m in love with that sparkle. Inexpensive enough to wear as an every day piece, and high quality enough for date nights.",
         "length": 257,
         "handle": "saturn-necklace"
      },
      {
         "nickname": "Arwyn A.",
         "review": "I usually don't spend money on jewelry, but I found serendipity on Tik Tok and fell in love with these pieces. I've had this necklace for about a month, and there's no signs of wear on it, which was one of the things I was worried about - I've had experiences in the past with other businesses where the jewelry, generally around the clasp, would break super easily. This has held up against my day to day life, and remains as beautiful as the day I got it. My friend and I have matching ones now, and she loves hers too! I would definitely recommend this.",
         "length": 556,
         "handle": "saturn-necklace"
      }
   ],
   "7581234692329" : [
      {
         "nickname": "Sandra M.",
         "review": "This necklace is absolutely stunning! Shipping was great and I can’t wait to give it to my friend for her birthday! I just know she’ll love it!",
         "length": 257,
         "handle": "moon-phase-locket"
      },
      {
         "nickname": "Lib H.",
         "review": "I absolutely ADORE my necklace from Serendipity! I got the Waning Crescent Moon Phase Locket and I wear it ALL the time and the interior space was perfect for a photo!",
         "length": 150,
         "handle": "moon-phase-locket"
      },
      {
         "nickname": "America H.",
         "review": "Everything was packaged nicely and the locket seems to be really good quality so far!",
         "length": 100,
         "handle": "moon-phase-locket"
      },
      {
         "nickname": "Belinda M.",
         "review": "The chain was very delicate and broke when I first wore it. I reached out to customer service to let them know and they offered to send me a thicker chain to replace it.",
         "length": 257,
         "handle": "moon-phase-locket"
      }
   ],
   "7351431790766": [
      {
         "nickname": "Diana M.",
         "review": "This is the most beautiful jewelry I have bought in a while. I purchased a necklace and it broke the sealer was so kind to help me out and resend me a replacement. The jewelry is so sparkly in the light.  Thank you so much can wait to buy more beautiful jewelry.",
         "length": 262,
         "handle": "replacement-1"
      }
   ],
   "6077126672558": [
      {
         "nickname": "Veronica  A.",
         "review": "Everything went smoothly! It was a great price for the quality. It’s so beautiful and delicate. The necklace is the perfect length and the ring is adjustable but it fits me! The earnings are gorgeous, the perfect match! I want another pair! I love it ! Thank You :) ",
         "length": 266,
         "handle": "stardew-natural-gemstone-set"
      }
   ],
   "4752165732436": [
      {
         "nickname": "Diane c.",
         "review": "This beautiful bracelet is just that and more! Beautiful !! \nI wore it the next day and everyone that saw it commented on it how beautiful it was!! \nI love it 🥰.... Thank You so much for your creativity as I will be ordering more items like the tourmaline stones just to carry around !! 👍👍👍",
         "length": 294,
         "handle": "black-tourmaline-cuff-5"
      }
   ],
   "7056132833454": [
      {
         "nickname": "miguel o.",
         "review": "my daughter showed me this and asked if i could get it for her for christmas so being the AMAZING DAD that i am i did.She loved it and hasnt taken it off yet.Very good quality and very amazing piece of jewelry.money well spent to make my baby (23) very happy.thanks guys and im sure you will see me again(happily so)",
         "length": 316,
         "handle": "serena-chain"
      }
   ],
   "6541503824046": [
      {
         "nickname": "Abdiel S.",
         "review": "Well worth the money! Amazing Quality!! I chose the Amethyst geode box to present the ring to my gf, who obviously said yes and is now my fiancée!!! Her friends love the idea of a geode ring box and love the picture she took with the ring inside it.  Thank you for making a special moment, a unforgettable memory with a beautiful item!",
         "length": 335,
         "handle": "amethyst-geode-box"
      }
   ],
   "4762016612436": [
      {
         "nickname": "Tiffany D.",
         "review": "There was a mixup with my order and I received the wrong item. I got the best customer service ever. Customer service alone is five stars off the charts! I will definitely do business with them again. However when I finally got this necklace which was the correct item, I was surprised how small it was. It is still very beautiful. So I only took off one star simply because of the size. ",
         "length": 388,
         "handle": "evil-eye-necklace-2"
      }
   ],
   "4767857410132": [
      {
         "nickname": "Emma H.",
         "review": "I bought this ring for my best friend as a special present. I was kinda skeptical on the purchase, since I only knew this website from tik tok. It arrived very quickly, within a week and a half. The packaging was AMAZING, it came with a cute little felt bag. The ring itself is absolutely perfect. The gold is very stable but molds easily to adjust the size. The crystal itself is 100% real and in great condition and looks great. I would definitely order from here again. ",
         "length": 473,
         "handle": "amethyst-statement-ring-1"
      }
   ],
   "5976864555182": [
      {
         "nickname": "Madeleine B.",
         "review": "Such a beautiful necklace. I got it as a present for my mother as tigers eye is a protective stone. The piece itself is so amazing, the stone has this sparkle or almost holographic look to it that catches the light. It comes wrapped in this dark purple tissue paper that I used. The necklace was a beautiful light purple pouch with a tiny little dropper that you use to insert the oils into the necklace. Overall a beautiful present that was presented very well. Would totally buy from them again!!! ",
         "length": 500,
         "handle": "tigers-eye-essential-oil-perfume-bottle-necklace"
      }
   ],
   "4705180254292": [
      {
         "nickname": "Esha D.",
         "review": "I received my order in a beautiful little package. First, of all, I was blown away by the cutest little purple bag which contained my precious scorp necklace. And girrrl! I ABSOLUTELY LOVEEEEE IT. \nFurther, I was so thrilled to hold the pocket unakites and the rhodonite and when I peered in I was so freaking intrigued to see the four other stunning crystals that you packaged for me as a birthday gift. I fall short of words to express how much loving energy I received from you. Thank you for such precious presents, serendipity!!!\n\nAnd finally! Selenite! it is my first time holding a selenite. and this wand you picked for me is truly magical. \nDefinitely recommending it all my friends and coming back for more!",
         "length": 717,
         "handle": "scorpio-necklace"
      }
   ]
}


var section = document.querySelector('#shopify-section-template--16846202011881__1655919697c1bcb079');
if (!section) {
   section = document.querySelector('#shopify-section-template--16846202011881__1655919697c1bcb079');
}
const allReviews = Object.keys(reviews).reduce((inital,newvalue) => inital.concat(reviews[newvalue]),[])


var productInfo = document.querySelector('#custom-review-highlights');
var title = productInfo.dataset.productTitle.toLowerCase()
var id = productInfo.dataset.productId

setReviews() // entry

function setReviews() {
   if (!section || !title || !id) {
      console.log("section title id not found for word reviews.")
      return 
   }

   var reviewsForID = reviews[id] || []
   if (reviewsForID.count >= 5) {
      replaceReviews(reviews)
      return
   }

   const reviewsNeeded = 5 - reviewsForID.length
   var otherReviews = findReviewsForTitle(title).sort( function() { return 0.5 - Math.random() } )
   if (otherReviews.length > reviewsNeeded) {
      for (var i = 0; i < reviewsNeeded; i++) {
         reviewsForID.push(otherReviews[i])
      }
      replaceReviews(reviewsForID)
   }
}


// takes a set of 5 reviews and replaces them on the page
function replaceReviews(reviews) {
   if (!reviews || reviews.length < 5) { return }
   var slides = section.getElementsByClassName("testimonials-slide");
   for (var i = 0; i < slides.length; i++) {
      var review = reviews[i]
      var element = slides[i]
      element.getElementsByTagName("cite")[0].innerHTML = review.nickname
      element.getElementsByTagName("p")[0].innerHTML = review.review
   }
   section.children[1].style = ""

}


function findReviewsForTitle(productTitle) {
  var reviewGroups = [["locket","necklace","chain","bundle"],["earring","stud","huggie","hoop"], ["ring"],["cuff","bracelet"], ["box"]]
  var matchedGroup
  reviewGroups.every((group) => {
    const matchedTitles = group.filter((i) => { return productTitle.includes(i) })
    if (matchedTitles.length > 0) {
      matchedGroup = group
      return false 
    } else {
      return true
    }
  })
  if (!matchedGroup) {
   return []
  }
  return reviewsforTitles(matchedGroup)
}


function reviewsforTitles(titleArray) {
  return [].concat.apply([],titleArray.map(reviewsForTitle))
}

function reviewsForTitle(string) {
  
  return allReviews.filter(function(item){
    return item.handle.toLowerCase().includes(string.toLowerCase())
  })  
}

function reviewForProductID(productID) {
	return reviews[productID]
}


